import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves exposure options basic information
 */

export function getExpoOptionsData(_this) {
  gatewayService.currencies
    .exposureOption({ format: "json" })
    .then(data => {
      _this.expoOptions = data;
      let txt = "One of the following: ";
      _this.expoOptions.forEach((d, i) =>
        i < _this.expoOptions.length - 1
          ? (txt += d.name + ", ")
          : (txt += d.name + ".")
      );
      var index = _this.headersExpo1
        .map(function(d) {
          return d.text;
        })
        .indexOf("Exposure Type");
      if (index > -1) {
        _this.headersExpo1[index].explain = txt;
      } else {
        console.log("Could not load expoOptions to headersExpo1");
      }
    })
    .catch(function(error) {
      console.log(error);
    });
}
